export default __webpack_public_path__ + "static/media/FPjunctionbox.6d3cc25a.png";